export const SubCommunityTypeIdEnum = {
  lookupTypeId: 20,
};
